import { Component, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EditProfileQueryData, SubmitEditProfileData } from 'globals/store/share.data';
import { Sponsor, sponsorProps } from 'globals/store/sponsors.data';
import { ShareWrapper } from './share-wrapper.component';
import { CustomQuestion } from 'globals/store/events.data';
import { BrandingData } from 'globals/store/publish.data';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { CustomQuestionsComponent } from 'src/app/components/entities/custom-questions.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { SocialLinksComponent } from 'src/app/components/social-links/social-links.component';
import { CommonModule } from '@angular/common';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { MatButtonModule } from '@angular/material/button';
import { Subject } from 'rxjs';

@Component({
    selector: 'share-edit-sponsor',
    template: `
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !sponsor" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your details have been submitted.
  </div>
  <div class="container" *ngIf="sponsor && !submitted">
    <div class="event-name" *ngIf="eventName">{{ sponsor.name }} Profile in {{ eventName }}</div>
    <div class="top">
      <div class="photos">
        <image-uploader 
          #logoEditor 
          [id]="sponsor.id" 
          [maxSize]="1024*1024*10" 
          [public]="true" 
          [isLogo]="true"
          [photoUrl]="sponsor.fullLogoUrl"
          [publishCode]="publishCode"
          [hints]="imageHints"
          [eventId]="eventId"
          placeholder="Add logo" 
          uploadText="UPLOAD LOGO"
          type="sponsor" 
          subtype="logo"
        ></image-uploader>
      </div>
      <div class="fields">
        <mutating-input [object]="sponsor" [prop]="props.name" placeholder="Sponsor name"></mutating-input>
        <add-manage-wrapper class="social-open" [hideHRule]="true" wrapperTitle="SOCIAL" [openLabel]="!sponsor.social?.length ? '+ ADD A SOCIAL LINK' : 'MANAGE SOCIAL LINKS'" (open)="openSocialLinks($event, sponsor)">
          <social-links *ngIf="sponsor?.social?.length" [socialLinks]="sponsor.social"></social-links>  

        </add-manage-wrapper>
        <h5>Description</h5>
        <input-editor 
          class="placeholder-no-italics"
          [object]="sponsor" 
          [forceSave]="forceSave" 
          [prop]="props.description" 
          [placeholder]="'Click to add description...'"
        ></input-editor>
        <mutating-input [object]="sponsor" [prop]="props.callToAction" placeholder="Call to action text"></mutating-input>
        <mutating-input 
          [object]="sponsor" 
          [prop]="props.callToActionUrl" 
          [placeholder]="'Call to action URL (Must start with http or https)'"
          [error]="CTAInvalid ? 'URL must start with http:// or https://' : null"
          (textChange)="checkLinkOK(); changed = true;"
          (unfocus)="checkLink(); changed = true;"
        ></mutating-input>
      </div>
    </div>
    <div class="bottom">
      <mutating-input [object]="sponsor" [prop]="props.contactName" placeholder="Sponsor contact name"></mutating-input>
      <mutating-input [object]="sponsor" [prop]="props.contactNumber"  placeholder="Sponsor contact phone" ></mutating-input>
      <mutating-input [object]="sponsor" [prop]="props.contactEmail" placeholder="Sponsor contact email" ></mutating-input>
      <h5>Sponsor contact address</h5>
      <input-editor 
        class="placeholder-no-italics"
        [object]="sponsor" 
        [prop]="'contactFullAddress'" 
        [placeholder]="'Sponsor contact address...'"
      ></input-editor>

      <custom-questions
        [entity]="sponsor"
        [questions]="customQuestions"
        [showMandatoryWarnings]="showMandatoryWarnings"
        [shareView]="true"
        (updateQuestion)="updateCustomQuestion($event, sponsor)"
      ></custom-questions>

      <button mat-button color="primary" (click)="submit()" [disabled]="processing || logoEditor.imageChanging" >
        <div class="button_content">
          Submit
          <loader icon="button_wheel"></loader>
        </div>
      </button>
      <div class="error-holder" *ngIf="error" [innerHTML]="helpers.strWithBreak(error)"></div>
    </div>
  </div>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [BrandingWrapperComponent, MatButtonModule, ImageUploaderComponent, LoaderComponent, CustomQuestionsComponent,InputEditorComponent, MutatingInputComponent,SocialLinksComponent,  CommonModule, AddManageWrapperComponent,]
})
export class SponsorEditComponent extends ShareWrapper<SponsorEditComponent> {
    @ViewChild('logoEditor') logoEditor
    publishCode:string;
    props = sponsorProps
    eventId;
    eventName: string
    showMandatoryWarnings = false;
    cannotSubmitMessage = "The sponsor profile can't be submitted at this time.\nPlease reload this page and try again."
    sponsor: Sponsor
    inactiveUrlMessage = "The sponsor profile is not currently available for editing.\n\nTo review or update your profile, please contact the event organiser and ask them to re-activate your edit webform."
    changed = false
    CTAInvalid = false
    customQuestions: CustomQuestion[] = []
    brandingData: BrandingData
    forceSave: Subject<void> = new Subject<void>();

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.publishCode = params.publishCode;
          const queryData: EditProfileQueryData = { publishCode:this.publishCode, entityType: 'sponsor' }
          this.publicService.loadEditProfile(queryData).then(profile => {
            this.loading = false;
            if (!profile) {
              document.title = "Unavailable";
              return
            }
            console.log(profile)
            this.loading = false;
            this.sponsor = profile.entity as Sponsor
            this.eventId = profile.eventId
            this.eventName = profile.eventName
            document.title = "Edit sponsor "+this.sponsor.name;
            this.customQuestions = profile.customQuestions || []
            this.brandingData = profile.brandingData
            this.template = profile.brandingData?.template
          })
        }
        document.title = "loading";
      })
    }

    checkLinkOK() { // so can show it's okay after typing a valid start
      const url = this.sponsor.callToActionUrl
      if (!url || this.helpers.urlOk(url)) this.CTAInvalid = false
    }

    checkLink() {
      const url = this.sponsor.callToActionUrl
      this.CTAInvalid = !!url && !this.helpers.urlOk(url)
    }
    
    async submit(){
      // CHECK FOR MANDATORY FIELDS
      this.forceSave.next();
      const allRequirementsCompleted = await this.publicService.checkForMandatory(this.customQuestions, this.sponsor.customQuestions);
      if(!allRequirementsCompleted) {
        this.showMandatoryWarnings = true;
        return;
      }
      this.processing = true;
      if (this.logoEditor.deleteDeletedPhotos()) {
        this.sponsor.logoUrl = this.logoEditor.tempThumbUrl
        this.sponsor.fullLogoUrl = this.logoEditor.tempUrl
      }
      const data: SubmitEditProfileData = {
        publishCode:this.publishCode,
        entity:this.sponsor,
        eventId: this.eventId,
        entityType: 'sponsor'
      }
      const successfullySubmitted = await this.publicService.submitEditProfile(data)
      this.processing = false;
      if (successfullySubmitted) this.submitted = true;
      else this.showError(this.cannotSubmitMessage)
    }
}

